import base from './base';
import axios from '../http';
import qs from 'querystring';

const receipt = {
	getList(page) {
		return axios.get(`${base.serverUrl}/receipts`, {params: {page}});
	},
	getReceiptDetail(receipt_id) {
		return axios.get(`${base.serverUrl}/receipt/${receipt_id}/goods`);
	},
	getInbounds(receipt_id, goods_id) {
		return axios.get(`${base.serverUrl}/receipt/${receipt_id}/goods/${goods_id}/inbounds`);
	},
	finishReceipt(receipt_id) {
		return axios.post(`${base.serverUrl}/receipt/${receipt_id}/finish`);
	},
	checkReceipt(receipt_id) {
		return axios.get(`${base.serverUrl}/receipt/${receipt_id}/check`);
	},
	terminateReceipt(receipt_id, goods) {
		return axios.post(`${base.serverUrl}/receipt/${receipt_id}/terminate`, goods);
	},
	search(adoption_id) {
		return axios.get(`${base.serverUrl}/receipt/by_adoption_id/${adoption_id}`);
	}
};

export default receipt;